// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"223":"22987d31","247":"34a25f03","640":"ced21ab3","878":"d5db10e9"}[chunkId] + ".css";
};